import { inject, Injectable } from '@angular/core';
import { MatDialog } from '@angular/material/dialog';
import { Actions, ofActionSuccessful } from '@ngxs/store';
import { Logger } from 'vite';
import { ReportVideoDialogComponent } from '../reportDisplay/report-video-dialog.component';
import { LaunchVideo } from '../state/report.actions';

@Injectable({
    providedIn: 'root'
})
export class ReportVideoLauncherService {
    private actions$ = inject(Actions);
    private dialog = inject(MatDialog);

    init() {
        this.actions$.pipe(ofActionSuccessful(LaunchVideo)).subscribe((action: LaunchVideo) => {
            this.dialog.open(ReportVideoDialogComponent, {
                data: action.payload.url.url,
                autoFocus: false,
            });
        });
    }
}
